import * as React from "react";
import { Breadcrumbs as MantineBreadcrumbs } from "@mantine/core";
const Breadcrumbs = ({ ...props }) => /* @__PURE__ */ React.createElement(MantineBreadcrumbs, { ...props });
export default Breadcrumbs;
